import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';

// import { useAuth } from 'Context/auth';
import { useUserStore } from 'Store/userStore';

function GuardedComponent({ component: Component, guarded = false, allowRoles = undefined, ...rest }) {
    // const { user } = useAuth();
    const user = useUserStore((state) => state.user);
    const location = useLocation();
    return (
        <Route
            {...rest}
            render={(props) =>
                !guarded || (guarded && user) ? (
                    !allowRoles || (allowRoles && allowRoles.includes(user.ROLE)) ? (
                        <Component {...props} />
                    ) : (
                        <Redirect to="/apps" />
                    )
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { referrer: `${location.pathname}${location.search}` },
                        }}
                    />
                )
            }
        />
    );
}

export default GuardedComponent;
